<template>
  <section id="articles">
    <Header :class="{header: true, hidden: hideHeader}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div class="loading" v-if="loading">
      <div class="lMT"></div>
      <div class="lWrp">
        <div class="loadingCnt">
          <div class="ttl ttl1"></div>
          <div class="lItCnt">
            <div class="lIt"></div>
            <div class="lIt"></div>
            <div class="lIt"></div>
            <div class="lIt"></div>
          </div>
        </div>
      </div>
      <div class="lWrp gr">
        <div class="loadingCnt loadingCnt2">
          <div class="ttl ttl1"></div>
          <div class="lItCnt">
            <div class="lIt"></div>
            <div class="lIt"></div>
            <div class="lIt"></div>
            <div class="lIt"></div>
          </div>
        </div>
      </div>
      <div class="lWrp">
        <div class="loadingCnt loadingCnt2 loadingCnt3">
          <div class="ttl ttl1"></div>
          <div class="lItCnt">
            <div class="lIt"></div>
            <div class="lIt"></div>
            <div class="lIt"></div>
            <div class="lIt"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div :class="{tabMenu: true, hidden: hideHeader}">
        <div class="tabMenuWrapper" v-if="page === 'sumber-dan-materi'">
          <a href="#articles" :class="{tabMenuItem: true, active: menuActive === 'krisis-iklim'}">
            Krisis Iklim</a>
          <a href="#kabarIklim" :class="{tabMenuItem: true, active: menuActive === 'kabar-iklim'}">
            Kabar Dan Berita</a>
          <a href="#infografis" :class="{tabMenuItem: true, active: menuActive === 'infografis'}">
            Insights/Infografis</a>
          <a href="#artikle" :class="{tabMenuItem: true, active: menuActive === 'articles'}">
            Artikel</a>
        </div>
        <div class="tabMenuWrapper" v-if="page === 'bicara-bumi'">
          <a href="#articles" :class="{tabMenuItem: true,
            active: menuActive === 'humans-of-climate'}">
            Manusia dan Iklim</a>
          <a href="#shortMovie" :class="{tabMenuItem: true, active: menuActive === 'short-movie'}">
            Bercakap Iklim</a>
          <a href="#podcast" :class="{tabMenuItem: true, active: menuActive === 'podcast'}">
            Kelas Iklim</a>
        </div>
      </div>

      <div class="sectionCnt" v-if="page === 'sumber-dan-materi'">

        <div class="pageInfo bumiKini">
          <div class="pageInfoWrapper">
            <h2>Sumber dan Materi</h2>
            <h4>Mengenal dan memahami kondisi bumi saat ini, di bawah ancaman krisis iklim.</h4>
            <p>Langkah awal dimulai dengan mengetahui bagaimana krisis iklim mempengaruhi
              kehidupan kita, dulu, kini, dan di kemudian hari. Tak ketinggalan, pantau
              selalu kabar terkini mengenai laju krisis iklim yang kian mengancam di depan mata.</p>
          </div>
        </div>

        <div class="section" v-if="krisisIklim.length > 0">
          <h4 class="sectionTitle">Krisis Iklim 101</h4>
          <p class="sectionSubtitle">Mengemas berbagai informasi dasar seputar krisis
            iklim yang perlu kita ketahui dan pahami.</p>
          <div class="sectionContent">
            <div class="sectionItem" v-for="item in krisisIklim" :key="item.id">
              <div class="sectionImg" v-on:click="viewContent(item)">
                <div class="theImg" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                <span class="view"></span>
                <div class="tags">
                  <div class="igLogo" v-if="item.type === 'Instagram Post'
                    && item.event && item.event.url"></div>
                  <div class="multipleImage"
                    v-if="item.type === 'Instagram Post' && item.event.images.length > 1"></div>
                </div>
              </div>
              <h4 v-on:click="viewContent(item)">{{item.title}}</h4>
            </div>
          </div>
        </div>

        <div class="kabarIklim gr" v-if="kabarIklim.length > 0">
          <div id="kabarIklim" ref="kabarIklim" class="scSteper"></div>
          <div class="section">
            <h4 class="sectionTitle">Kabar Iklim</h4>
            <p class="sectionSubtitle">Pilihan informasi krisis iklim terkini yang tak
              boleh dilewatkan..</p>
            <div class="sectionContent">
              <div class="sectionItem" v-for="item in kabarIklim" :key="item.id">
                <div class="sectionImg" v-on:click="viewContent(item)">
                  <div class="theImg" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                  <span class="view"></span>
                  <div class="tags">
                    <div class="igLogo" v-if="item.type === 'Instagram Post'
                      && item.event && item.event.url"></div>
                    <div class="multipleImage"
                      v-if="item.type === 'Instagram Post' && item.event.images.length > 1"></div>
                  </div>
                </div>
                <h4 v-on:click="viewContent(item)">{{item.title}}</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="infografis" v-if="infografis.length > 0">
          <div id="infografis" ref="infografis" class="scSteper"></div>
          <div class="infografisCnt">
            <h4 class="sectionTitle">Insights/Infografis</h4>
            <div class="sectionContent">
              <div class="sectionItem" v-for="item in infografis" :key="item.id">
                <div class="sectionImg" v-on:click="viewContent(item)">
                  <div class="theImg" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                  <span class="view"></span>
                  <div class="tags">
                    <div class="igLogo" v-if="item.type === 'Instagram Post'
                      && item.event && item.event.url"></div>
                    <div class="multipleImage"
                      v-if="item.type === 'Instagram Post' && item.event.images.length > 1"></div>
                  </div>
                </div>
                <h4 v-on:click="viewContent(item)">{{item.title}}</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="kabarIklim" v-if="gpArticles.length > 0">
          <div id="artikle" ref="gpArticles" class="scSteper"></div>
          <div class="section">
            <h4 class="sectionTitle">Artikel</h4>
            <div class="sectionContent">
              <div class="sectionItem" v-for="item in gpArticles" :key="item.id">
                <div class="sectionImg" v-on:click="viewLink(item)">
                  <div class="theImg" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                  <span class="view"></span>
                </div>
                <h4 v-on:click="viewLink(item)">{{item.title}}</h4>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="sectionCnt" v-if="page === 'bicara-bumi'">

        <div class="pageInfo bicaraBumi">
          <div class="pageInfoWrapper">
            <h2>Bicara Bumi</h2>
            <h4>Membahas lebih jauh permasalahan krisis iklim serta upaya peredamannya.</h4>
            <p>Sebuah wujud pembahasan mendalam krisis iklim sebagai krisis kemanusiaan
              yang begitu dekat dan berdampak bagi kehidupan kita.</p>
          </div>
        </div>

        <div class="section">
          <div v-if="humansOfClimate.length > 0">
            <h4 class="sectionTitle">Manusia dan Iklim</h4>
            <p class="sectionSubtitle">Mengulas beberapa individu ataupun kelompok yang
              berkaitan erat dengan krisis iklim, mulai dari masyarakat terdampak,
              hingga para ahli dan aktivis.</p>
            <div class="sectionContent">
              <div class="sectionItem" v-for="item in humansOfClimate" :key="item.id">
                <div class="sectionImg" v-on:click="viewContent(item)">
                  <div class="theImg" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                  <span class="view"></span>
                  <div class="tags">
                    <div class="igLogo" v-if="item.type === 'Instagram Post'
                      && item.event && item.event.url"></div>
                    <div class="multipleImage"
                      v-if="item.type === 'Instagram Post' && item.event.images.length > 1"></div>
                  </div>
                </div>
                <h4 v-on:click="viewContent(item)">{{item.title}}</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="kabarIklim shortMovie">
          <div id="shortMovie" ref="shortMovie" class="scSteper"></div>
          <div class="section">
            <div v-if="shortMovie.length > 0">
              <h4 class="sectionTitle">Bercakap Iklim</h4>
              <p class="sectionSubtitle">Suatu penuturan-penuturan singkat mengenai sejumlah
                masalah yang begitu dekat dengan keseharian kita, tapi justru begitu
                berpengaruh bagi laju krisis iklim.</p>
              <div class="sectionContent">
                <div class="sectionItem" v-for="item in shortMovie" :key="item.id">
                  <div class="sectionImg" v-on:click="$emit('play', item)">
                    <div class="theImg" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                    <div class="imgOverlay">
                      <div class="playBtn">
                        <div class="playIcon"></div>
                        Tonton video
                        <span>{{item.duration}}</span>
                      </div>
                    </div>
                    <span class="view"></span>
                    <div class="tags">
                      <div class="igLogo" v-if="item.type === 'Instagram Post'
                        && item.event && item.event.url"></div>
                      <div class="multipleImage"
                        v-if="item.type === 'Instagram Post' && item.event.images.length > 1"></div>
                    </div>
                  </div>
                  <h4 v-on:click="$emit('play', item)">{{item.title}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="kabarIklim gr">
          <div id="podcast" ref="podcast" class="scSteper"></div>
          <div class="section">
            <div v-if="podcast.length > 0">
              <h4 class="sectionTitle">Kelas Iklim</h4>
              <p class="sectionSubtitle">Mengulas kembali sesi kelas iklim yang
                membahas komitmen Indonesia bagi bumi.</p>
              <div class="sectionContent">
                <div class="sectionItem" v-for="item in podcast" :key="item.id">
                  <div class="sectionImg" v-on:click="$emit('play', item)">
                    <div :class="{theImg: true, audio: !item.video && item.audio && !item.thumb}"
                      :style="{backgroundImage: `url(${item.thumb})`}"></div>
                    <span class="view"></span>
                    <div class="imgOverlay">
                      <div class="playBtn">
                        <div class="playIcon"></div>
                        Dengarkan
                        <span>{{item.duration}}</span>
                      </div>
                    </div>
                    <div class="tags">
                      <div class="igLogo" v-if="item.type === 'Instagram Post'
                        && item.event && item.event.url"></div>
                      <div class="multipleImage"
                        v-if="item.type === 'Instagram Post' && item.event.images.length > 1"></div>
                    </div>
                  </div>
                  <h4 v-on:click="$emit('play', item)">{{item.title}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      loading: true,
      prevScrollpos: 0,
      hideHeader: false,
      krisisIklim: [],
      kabarIklim: [],
      infografis: [],
      gpArticles: [],
      humansOfClimate: [],
      podcast: [],
      shortMovie: [],
      page: '',
      bumiKiniInitialized: false,
      bicaraBumiInitialized: false,
      menuActive: '',
    };
  },
  computed: {
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    this.prevScrollpos = window.pageYOffset;
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    viewContent(item) {
      if (item.type === 'Article') {
        this.$router.push(`/${item.parent.slug}/read/${item.slug}`);
      } else {
        this.$emit('viewContent', item);
      }
    },
    viewLink(item) {
      if (item.event && item.event.url) {
        window.open(item.event.url);
      }
    },
    onScrolled() {
      if (this.page === 'sumber-dan-materi') {
        const kabarIklimRect = this.$refs.kabarIklim.getBoundingClientRect();
        const kabarIklimOffTop = kabarIklimRect.top + window.pageYOffset;
        const infografisRect = this.$refs.infografis.getBoundingClientRect();
        const infografisOffTop = infografisRect.top + window.pageYOffset;
        const articleRect = this.$refs.gpArticles.getBoundingClientRect();
        const articleOffTop = articleRect.top + window.pageYOffset;
        if (window.pageYOffset >= articleOffTop) {
          this.menuActive = 'articles';
        } else if (window.pageYOffset >= infografisOffTop) {
          this.menuActive = 'infografis';
        } else if (window.pageYOffset >= kabarIklimOffTop) {
          this.menuActive = 'kabar-iklim';
        } else {
          this.menuActive = 'krisis-iklim';
        }
      } else if (this.page === 'bicara-bumi') {
        const podcastRect = this.$refs.podcast.getBoundingClientRect();
        const podcastOffTop = podcastRect.top + window.pageYOffset;
        const shortMovieRect = this.$refs.shortMovie.getBoundingClientRect();
        const shortMovieOffTop = shortMovieRect.top + window.pageYOffset;
        if (window.pageYOffset >= podcastOffTop) {
          this.menuActive = 'podcast';
        } else if (window.pageYOffset >= shortMovieOffTop) {
          this.menuActive = 'short-movie';
        } else {
          this.menuActive = 'humans-of-climate';
        }
      }
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 300) {
        if (this.prevScrollpos > currentScrollPos) {
          this.hideHeader = false;
        } else {
          this.hideHeader = true;
        }
      } else {
        this.hideHeader = false;
      }
      this.prevScrollpos = currentScrollPos;
    },
    getData() {
      if (this.page === 'sumber-dan-materi') {
        this.menuActive = 'krisis-iklim';
        if (!this.bumiKiniInitialized) {
          this.loading = true;
          this.bumiKiniInitialized = true;
          this.$http.get(this.$config.uri('article/all?parent=krisis-iklim'))
            .then((response) => {
              this.krisisIklim = (response.data.status === 200) ? response.data.data : [];
              // this.loading = false;
            });
          this.$http.get(this.$config.uri('article/all?parent=kabar-dan-berita'))
            .then((response) => {
              this.kabarIklim = (response.data.status === 200) ? response.data.data : [];
              // this.loading = false;
            });
          this.$http.get(this.$config.uri('article/all?parent=infografis'))
            .then((response) => {
              this.infografis = (response.data.status === 200) ? response.data.data : [];
              this.loading = false;
            });
          this.$http.get(this.$config.uri('article/all?parent=external-article'))
            .then((response) => {
              this.gpArticles = (response.data.status === 200) ? response.data.data : [];
            });
        } else {
          this.loading = false;
        }
      } else if (this.page === 'bicara-bumi') {
        this.menuActive = 'humans-of-climate';
        if (!this.bicaraBumiInitialized) {
          this.loading = true;
          this.bicaraBumiInitialized = true;
          this.$http.get(this.$config.uri('article/all?parent=humans-of-climate'))
            .then((response) => {
              this.humansOfClimate = (response.data.status === 200) ? response.data.data : [];
              this.loading = false;
            });
          this.$http.get(this.$config.uri('podcast/all/kelas-iklim')).then((response) => {
            this.podcast = (response.data.status === 200) ? response.data.data : [];
            this.loading = false;
          });
          this.$http.get(this.$config.uri('podcast/all/short-movie')).then((response) => {
            this.shortMovie = (response.data.status === 200) ? response.data.data : [];
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.params.slug;
      this.getData();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    this.chMenuActive('sumber-dan-materi');
    this.page = this.$route.params.slug;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = (this.page === 'bicara-bumi')
      ? 'Bicara Bumi - Bumi Butuh Aksi'
      : 'Sumber dan Materi - Bumi Butuh Aksi';
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.loading{
  padding-top: 80px;
  position: relative;
  overflow: hidden;
  &:before{
    content: "";
    display: block;
    position: absolute;
    top: -40px;
    bottom: -40px;
    left: -200px;
    width: 200px;
    background-image: linear-gradient(to right, transparent,#fff,transparent);
    transform: rotate(14deg);
    z-index: 2;
    animation: skAnimate 2.2s infinite;
    opacity: .8;
    @keyframes skAnimate {
      from { left: -200px; }
      to { left: calc(100% + 200px); }
    }
  }
  .lMT{
    height: 42px;
    background-color: #eee;
  }
  .lWrp{
    max-width: 1240px;
    margin: 0 auto;
  }
  .loadingCnt{
    &.loadingCnt2{
      margin-top: 94px;
      padding-top: 3px;
      .ttl{
        background-color: #eee;
      }
      .lIt{
        background-color: #eee;
      }
      &.loadingCnt3{
        margin-top: 104px;
        margin-bottom: 80px;
        background-color: #fff;
        .lIt{
          height: 524px;
        }
      }
    }
    .ttl{
      height: 30px;
      background-color: #eee;
      margin-bottom: 29px;
      max-width: 200px;
      &.ttl1{
        margin-top: 39px;
      }
    }
    .lItCnt{
      display: flex;
      margin: 0 -10px;
    }
    .lIt{
      height: 295px;
      width: calc(25% - 20px);
      margin: 0 10px;
      background-color: #eee;
    }
  }
}

.tabMenu{
  position: fixed;
  top: 80px;
  left: 0;
  background-color: #f5f5f5;
  right: 0;
  border-bottom: #eee 1px solid;
  transition: all .3s ease;
  z-index: 9;
  &.hidden{
    top: 0;
  }
  @media (max-width: 768px) {
    top: 64px;
  }
  .tabMenuWrapper{
    display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 0 10px;
    @media (max-width: 760px) {
      overflow-x: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .tabMenuItem{
      text-decoration: none;
      padding: 10px 20px 8px;
      color: #444;
      cursor: pointer;
      font-weight: 600;
      border-bottom: transparent 3px solid;
      margin-bottom: -1px;
      white-space: nowrap;
      &:hover{
        border-color: #999;
      }
      &.active{
        border-color: #31c1f4;
      }
    }
  }
}

.sectionCnt{
  padding-top: 114px;
  @media (max-width: 760px) {
    padding-top: 106px;
  }
  .pageInfo{
    background-image: url(../assets/bumi-kini.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    &:before{
      content: ""; display: block;
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      background-image: linear-gradient(rgba(77, 199, 161, 0.76), #fff);
    }
    &.bicaraBumi{
      background-image: url(../assets/bicara-bumi-2.jpg);
      background-position: top center;
      &:before{
        background-image: linear-gradient(rgba(49, 193, 244, 0.68), #fff);
      }
    }
    .pageInfoWrapper{
      position: relative;
      z-index: 2;
      max-width: 1240px;
      margin: 0 auto -120px;
      padding: 40px 0 160px;
      @media (max-width: 990px) {
        margin-bottom: -140px;
      }
      h2{
        margin: 0;
        font-size: 60px;
      }
      h4{
        margin: 0 0 10px;
        font-size: 24px;
        max-width: 700px;
      }
      p{
        margin: 0;
        max-width: 700px;
      }
      @media (max-width: 760px) {
        padding-top: 30px;
        h2{
          font-size: 50px;
          margin-left: -3px;
        }
        h4{
          font-size: 22px;
        }
      }
    }
  }
}
.section{
  max-width: 1240px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.sectionTitle{
  margin: 20px 0;
}
.sectionSubtitle{
  margin: -16px 0 26px;
  max-width: 700px;
}

.scSteper{
  position: absolute;
  top: -42px;
}
.kabarIklim{
  background-color: #f5f5f5;
  position: relative;
  overflow: hidden;

  // background-color: #96dec6;
  position: relative;
  overflow: hidden;
  margin: 30px 0 0;
  padding: 20px 0;
  .section{
    padding: 20px 0 10px;
    .sectionContent{
      .sectionItem{
        .sectionImg{
          background-color: #fff;
        }
      }
    }
  }
  &.shortMovie{
    background-color: #fff;
    .sectionContent{
      .sectionItem{
        .sectionImg{
          background-color: #eee;
        }
      }
    }
  }
  &.gr:before{
    background-image: url(../assets/trees.png);
    background-position: bottom center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 80px;
    height: 80px;
    display: block;
    position: absolute;
    right: 40px;
    bottom: -4px;
    content: "";
    opacity: .2;
  }
}

.infografis{
  position: relative;
  margin-top: 30px;
  .infografisCnt{
    max-width: 1240px;
    margin: 0 auto;
    padding: 20px 0 10px;
    .sectionContent{
      .sectionItem{
        .sectionImg{
          height: 524px;
        }
      }
    }
  }
}

.sectionContent{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  .sectionItem{
    width: calc(25% - 20px);
    margin: 0 10px 40px;;
    h4{
      margin: 0;
      padding: 10px 7px 0;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* number of lines to show */
      -webkit-box-orient: vertical;
      &:hover{
        color: #31c1f4;
      }
    }
    .sectionImg{
      width: 100%;
      height: 295px;
      position: relative;
      cursor: pointer;
      background-color: #eee;
      transition: all .2s ease;
      .tags{
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: center;
        .igLogo, .multipleImage{
          width: 20px;
          height: 18px;
          background-image: url(../assets/instagram-logo.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          margin-left: 10px;
        }
        .multipleImage{
          background-image: url(../assets/images.png);
          height: 22px;
        }
      }
      .theImg, .view{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-size: cover;
        background-position: center;
        z-index: 2;
      }
      .theImg.audio{
        background-color: #d9d6e4;
        background-image: url(../assets/musical-note.svg) !important;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 80px auto;
      }
      .imgOverlay{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: rgba(0,0,0,.6);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all .2s ease;
        z-index: 3;
        .playBtn{
          position: relative;
          font-size: 15px;
          padding: 4px 20px 6px;
          padding-left: 46px;
          border-radius: 100px;
          font-weight: bold;
          background-color: transparent;
          transition: all .2s ease;
          &:hover{
            background-color: #31c1f4;
          }
          .playIcon{
            width: 30px;
            height: 30px;
            position: absolute;
            left: 10px; top: 8px;
            background-image: url(../assets/play_circle_outline-white-18dp.svg);
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
          }
          span{
            display: block;
            font-size: 12px;
            font-weight: normal;
          }
        }
      }
      .view{
        left: 4px; top: 4px; right: -6px; bottom: -6px;
        background-color: #31c1f4;
        color: #fff;
        display: flex;
        align-items: center;
        transition: all .2s ease;
        justify-content: center;
        opacity: 0;
        z-index: 1;
      }
      &:hover{
        transform: scale(1.02);
        .imgOverlay{
          opacity: 1;
        }
        .view{
          opacity: 1;
        }
      }
    }
  }
}

#articles{
  min-height: 100vh;
}
</style>
